import { CaretRightFilled, PauseOutlined, StepBackwardFilled, StepForwardFilled } from "@ant-design/icons";
import { clockOf } from "../rules/format";
import { LEAD } from "../rules/proctoring";
import { SPEEDS, toneOf } from "../constants";

/*
 * Under the bar: previous / next flag, play, the modules as chapters, the
 * camera / screen switch (one clock), and the speeds.
 */
export default function Controls({
  t, playing, rate, modules, current, flagged = [], sources = [], source, onSource,
  onToggle, onSeek, onFlag, onRate,
}) {
  const prev = [...flagged].reverse().find((x) => x.at < t - LEAD - 0.5);
  const next = flagged.find((x) => x.at - LEAD > t + 0.5);
  return (
    <div className="proctoring-review__controls">
      <button type="button" className="proctoring-review__ctl" disabled={!prev} onClick={() => prev && onFlag(prev)} aria-label="Previous flag" title="Previous flag">
        <StepBackwardFilled />
      </button>
      <button type="button" className="proctoring-review__ctl proctoring-review__ctl--play" onClick={onToggle} aria-label={playing ? "Pause" : "Play"}>
        {playing ? <PauseOutlined /> : <CaretRightFilled />}
      </button>
      <button type="button" className="proctoring-review__ctl" disabled={!next} onClick={() => next && onFlag(next)} aria-label="Next flag" title="Next flag">
        <StepForwardFilled />
      </button>
      <div className="proctoring-review__chapters" role="group" aria-label="Go to a module">
        {modules.map((m, i) => (
          <button
            key={`${m.key}-${m.from}`}
            type="button"
            className={`proctoring-review__chapter${current === m ? " is-on" : ""}`}
            onClick={() => onSeek(m.from)}
            title={`${m.name}: ${clockOf(m.from)} to ${clockOf(m.to)}`}
          >
            <i style={{ background: toneOf(i).tone }} />
            {m.name}
          </button>
        ))}
      </div>
      <span className="proctoring-review__grow" />
      {sources.length > 1 && (
        <div className="proctoring-review__switch" role="group" aria-label="Recording shown">
          {sources.map((s) => (
            <button key={s.k} type="button" className={source === s.k ? "is-on" : ""} aria-pressed={source === s.k} onClick={() => onSource(s.k)}>
              {s.n}
            </button>
          ))}
        </div>
      )}
      <div className="proctoring-review__speeds" role="group" aria-label="Speed">
        {SPEEDS.map((x) => (
          <button key={x} type="button" className={rate === x ? "is-on" : ""} onClick={() => onRate(x)} aria-pressed={rate === x}>{`${x}×`}</button>
        ))}
      </div>
    </div>
  );
}
